<template>
  <el-dialog title="选择同步应用" :visible.sync="showDialog" width="400px">
    <div class="select-sync-content">
      <el-checkbox-group v-model="checkList" class="check-list">
        <el-checkbox-button class="app-check-item" v-for="item in appList" :label="item.value" :key="item.value" :disabled="isDisabledSf && item.value==3">{{
          item.label }}</el-checkbox-button>
      </el-checkbox-group>
      <div class="select-tip">*提示：若选中的人群中，包含人数数量≤1000的人群策略/人群包，不可同步至数坊应用</div>
    </div>
    <span slot="footer">
      <el-button style="margin-right: 10px;" @click="onClose">取 消</el-button>
      <el-button type="primary" @click="onSubmit" :loading="isLoading">确定同步</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {
  synDmps,
} from "@/api/precisionCrowdTask";
import {
  synDmp
} from "@/api/manage/memberCrowdController";
/**
 * 选择同步应用
 */
export default {
  name: 'SelectSyncApp',
  props: {
    value: {
      type: Boolean,
      default: false,
    },

    //选择同步的人群数据
    selectSyncArr: {
      type: Array,
      default: () => []
    },

    /**单行数据 */
    rowData: {
      type: Object,
      default: ()=> ({})
    },

    /**操作类型 single batch*/
    controlType: {
      type: String,
      default: 'single'
    }
  },
  data() {
    return {
      showDialog: false,
      appList: [
        { value: 3, label: '数坊' },
        { value: 1, label: 'DMP' },
      ],
      checkList: [],

      isDisabledSf: false, //是否禁用数坊
      isLoading: false,
    };
  },
  watch: {
    value(val) {
      this.showDialog = val;
      if (val) {
        if(this.controlType == 'batch') {
          //只要有一条数据
          this.isDisabledSf = this.selectSyncArr.some(item => item.count <= 1000)
        }else {
          this.isDisabledSf = this.rowData.count <= 1000 ? true : false
        }
      }
    }
  },
  methods: {
    onClose() {
      this.checkList = [];
      this.isDisabledSf = false;
      this.$emit('input', false)
    },

    onSubmit() {
      console.log('list>>',this.checkList)
      if(!this.checkList.length) return this.$message.warning('请选择要同步的应用')
      if(this.controlType == 'batch') {
        this.onHandleBatchSync();
      }else {
        this.onHandleSingleSync();
      }
    },

    //批量同步
    onHandleBatchSync() {
      let _delList = [];
      this.selectSyncArr.forEach(item => {
        let delItem = {
          precisionCrowdStrategyId: item.precisionCrowdStrategyId || "",
          dmpChannelType: this.checkList.join(',')
        };
        if (item.strategyId) {
          delItem.strategyId = item.strategyId;
        } else {
          delItem.searchId = item.searchId;
        }
        _delList.push(delItem);
      });
      this.isLoading = true;
      // console.log('_delList>>',_delList)
      // return
      synDmps(_delList).then(res => {
        if (res.code == 1) {
          this.dmpVisible = false
          this.$emit('update')
          this.$message.success("操作成功")
          this.onClose();
        } else {
          this.$message.warning(res.message)
        }
        this.isLoading = false
      }).catch(()=> {
        this.isLoading = false;
      })
    },

    // 单个同步
    onHandleSingleSync() {
      let param = {
        precisionCrowdStrategyId: this.rowData.precisionCrowdStrategyId,
        dmpChannelType: this.checkList.join(',')
      };
      if (this.rowData.strategyId) {
        param.strategyId = this.rowData.strategyId;
      } else {
        param.searchId = this.rowData.searchId;
      }
      this.isLoading = true;
      // console.log('param>>',param)
      // return
      synDmp(param).then(res => {
        if (res.code == "1") {
          if (res.data.code == "1") {
            this.$message.success("操作成功");
            this.onClose();
            this.$emit('update')
          } else {
            this.$message.error(res.data.errMsg);
          }
        }else {
          this.$message.warning(res.message)
        }
        this.isLoading = false;
      }).catch(()=> {
        this.isLoading = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-checkbox-button__inner {
  border: 1px solid #DCDFE6 !important;
  border-radius: 4px !important;
  width: 100px !important;
}

/deep/.el-checkbox-button.is-checked .el-checkbox-button__inner {
  border-color: transparent !important;
}

.select-sync-content {
  .check-list {
    text-align: center;
  }

  .app-check-item:nth-last-child(1) {
    margin-left: 20px;
  }

  .select-tip {
    color: red;
    margin-top: 20px;
  }
}
</style>
